import { useMutation, useQuery } from 'react-query';

import internalAPI from '../../helpers/internalAPI';

const BASE_NOTIFICATION_SETTINGS_URL = 'internal_api/v1/notification_settings';

export function useNotificationSettings() {
  const {
    data: requestData = { data: [] },
    error,
    isLoading,
  } = useQuery(['notification_settings'], () =>
    internalAPI.get(BASE_NOTIFICATION_SETTINGS_URL),
  );

  return {
    data: requestData?.data,
    errors: error,
    isLoading,
  };
}

export const useUpdateNotificationSettings = (options) =>
  useMutation(
    (params) => internalAPI.patch(BASE_NOTIFICATION_SETTINGS_URL, params),
    options,
  );
